<template>
    <div v-if="show" class="poster-wrap">
        <van-popup v-model:show="showPopup" round position="bottom" @click-overlay="closePopup">
            <div class="popup-title">请选择分享方式</div>
            <div class="share-panel">
                <div class="share-item" id="express" @click="toCreatePoster($event)">
                    <img src="@/assets/images/project/v3/poster.png" alt="">
                    <p>生成海报</p>
                </div>
            </div>
        </van-popup>

        <div class="poster-panel" ref="poster_canvas" id="capture">
            <div class="top-title">
                <div class="title1">
                    AL-LiNK高端智慧集成系统
                </div>
                <div class="title3">
                    用户真实体验
                </div>
                <div class="text">
                    “{{ objPoster.poster_title || '很满意史密斯这次的服务，采暖、 空调效果也非常好' }}”
                </div>
                <div class="name">
                    {{ '—— ' + (objPoster.city || '--') + '用户 ' + (objPoster.name || '--') }}
                </div>
            </div>
            <div class="poster-bgc">
                <img class="img" v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt=""/>
                <img class="img" v-else
                     src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/top-bgc.png"/>
            </div>
            <div class="title">
                {{ (objPoster.city || '--') + ' ｜ ' + (objPoster.community_name || '--') }}
            </div>
            <div class="info">
                <div class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/rl.png"/>
                    <div class="span span3">
                        {{ objPoster.created_at || '--' }}
                    </div>
                </div>
                <div v-if="objPoster.house_cate" class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/bs.png"/>
                    <div class="span">
                        {{ objPoster.house_cate }}
                    </div>
                </div>
                <div v-if="objPoster.house_area" class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/mj.png"/>
                    <div class="span span2">
                        {{ objPoster.house_area }}
                    </div>
                </div>
            </div>
            <div class="qr-wrap">
                <div class="qr-left">
                    <div class="top-qr">
                        <div class="name"> {{ objPoster.nickname || '--' }}</div>
                        <div class="tag">高级服务顾问</div>
                    </div>
                    <div class="b-qr">
                        <div>长按识别</div>
                        <div>了解用户真实体验</div>
                    </div>
                </div>
                <div class="qr-right" id="poster-qrcode" ref="poster_qrcode"></div>
                <div class="qr-head">
                    <img :src="objPoster.headimgurl" alt="">
                </div>
            </div>
            <div class="b-bg">
                <div class="logo-img">
                    <img src="@/assets/images/share/logo2.png" alt="">
                    <span>AI-LiNK好风好水智慧互联</span>
                </div>
                <div class="sp">
                    <img src="@/assets/images/share/sp3.png" alt="">
                </div>
            </div>
        </div>
        <div v-if="showPoster" @click.stop="toClosePoster" class="poster-pic">
            <img :src="posterPic" alt="" @click.stop="()=>{}">
            <img class="close" @click.stop="toClosePoster" src="@/assets/images/share/close_icon.png" alt="">
            <div class="tips">*长按保存图片<br/>*朋友圈文字已复制</div>
        </div>
    </div>
</template>

<script>
/*
*  评论分享
* */
import QRCode from "qrcodejs2";
import html2canvas from "@/libsV2/html2canvas";
import {getPosterInfo,getPosterDraft} from "@/js/project/v3/index.js";

export default {
    name: "posterPopup",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        disId: {
            type: String,
            default: ''
        },
        projectId: {
            type: String,
            default: ''
        }
    },
    watch: {
        show(value) {
            if (value) {
                setTimeout(() => {
                    this.showPopup = true;
                }, 50)
            } else {
                this.showPopup = false;
            }
        }
    },
    data() {
        return {
            showPopup: false,
            showPoster: false,
            posterPic: '',
            objPoster: {}
        }
    },
    methods: {
        closePopup() {
            this.$emit('close')
        },
        toCreatePoster(e) {
            // this.$common.pushEvent('project_share_discuss', this.projectId);
            var that = this;

            that.$store.commit("loadSwitch", true);

            getPosterDraft({
                project_uuid: this.projectId,
            }).then((res) => {
                this.objPoster = res.data.data.result;
                this.objPoster.date = this.objPoster.date ? this.objPoster.date.split(' ')[0] : ''
                setTimeout(() => {
                    that.qrcode = new QRCode(that.$refs.poster_qrcode, {
                        text: `${window.location.protocol}//${window.location.host}/project/v3/case/details` +
                            `?mode=2&id=${this.disId}&ut_source=${this.$route.query.ut_source}` +
                            `&shareId=${this.$storage.getStorage("user_id")}` +
                            `&track_action=project_share_discuss&track_id=${this.disId}&track_uuid=${sessionStorage.getItem('page_uuid')}`, //页面地址 ,如果页面需要参数传递请注意哈希模式#
                        width: 148,
                        height: 148,
                        colorDark: '#333',//二维码颜色
                        colorLight: '#fff',//二维码背景颜色
                        correctLevel: QRCode.CorrectLevel.L//容错率,L/M/H
                    })

                    setTimeout(() => {
                        let sHeight = that.$refs.poster_canvas.offsetHeight;
                        let sWidth = that.$refs.poster_canvas.offsetWidth;
                        html2canvas(that.$refs.poster_canvas, {
                            allowTaint: true, // 允许跨域图片
                            useCORS: true,
                            height: sHeight,
                            width: sWidth,
                            x: 2 * window.innerWidth,
                            y: 0,
                            scrollX: 0,
                            scrollY: 0,
                            dpi: window.devicePixelRatio,
                            scale: 2,
                        }).then((canvas) => {
                            const imgData = canvas.toDataURL("image/png");
                            that.posterPic = imgData
                            that.showPoster = true;
                            that.showPopup = false;
                            console.log('----')
                            that.$store.commit("loadSwitch", false);
                        });
                    }, 1000)
                }, 500)
            })
        },
        toClosePoster() {
            this.showPoster = false;
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
